import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'

import * as User from '../../../selectors/user'
import { Button, TextArea } from '../../shared/NarusMaterial'

import { updateHistoryNote } from './actions'

class NotesEdit extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      edit: false,
      note: ''
    }
    this.save = this.save.bind(this)
    this.edit = this.edit.bind(this)
    this.getNote = this.getNote.bind(this)
    this.hasAssessToEdit = this.hasAssessToEdit.bind(this)
  }

  getNote () {
    const { note } = this.props
    const v = _.chain(note)
      .get('extension', [])
      .find(
        f =>
          f.url ===
          'http://narushealth.com/fhir/episodeofcare-statusHistoryNote',
        {}
      )
      .get('valueString', '')
      .value()
    return v
  }

  hasAssessToEdit () {
    const { note, currentUser } = this.props
    const a = _.chain(note)
      .get('extension', [])
      .find(
        v =>
          v.url === 'http://narushealth.com/fhir/episodeofcare-practitioner',
        {}
      )
      .get('valueReference.reference', '')
      .value()
    return a && a === `Practitioner/${currentUser.sub}`
  }

  edit () {
    this.setState({
      edit: true,
      note: this.getNote()
    })
  }

  save () {
    const { note, notes, dispatch } = this.props
    const { note: stateNote } = this.state
    const i = notes.findIndex(
      v => JSON.stringify(v) === JSON.stringify(note)
    )

    if (i >= 0) {
      this.setState({ submitting: true })
      dispatch(
        updateHistoryNote(i, stateNote, () => {
          this.setState({
            edit: false,
            submitting: false
          })
        })
      )
    }
  }

  render () {
    const { edit, note, submitting } = this.state

    if (edit) {
      return (
        <div>
          <TextArea
            value={note}
            onChange={e => this.setState({ note: e.target.value })}
            name='note'
            label=''
            disabled={submitting}
          />
          <Button
            label=''
            onClick={this.save}
            disabled={submitting}
            style={{ float: 'right' }}
            grey
            long
          >
            <i className='fa fa-save' />
          </Button>
        </div>
      )
    }

    return (
      <span>
        {this.hasAssessToEdit() && (
          <Button
            label=''
            onClick={this.edit}
            grey
            style={{ float: 'right' }}
          >
            <i className='fa fa-pencil' />
          </Button>
        )}
        {this.getNote()}
        {' '}
      </span>
    )
  }
}

const mapStateToProps = redux => ({
  currentUser: User.getUserAuthData(redux)
})

export default connect(mapStateToProps)(NotesEdit)
